export default {"src":"/_next/static/media/houses_64.5322c387.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};